// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2336":"51961ebd","3458":"ef1c5392","5560":"82534ceb","6501":"ef1c5392","6911":"1575e7a9","9449":"7f6f4663","9604":"285c12ec"}[chunkId] + ".chunk.css";
};